// src/components/Sigil.tsx — small inline IR sigil for the header
// New file
import { CSSProperties, useId } from 'react';

interface Props { size?: number; style?: CSSProperties }

export function Sigil({ size = 30, style }: Props) {
  const uid = useId();
  const c = size / 2;
  const gradId = `sigil-g-${uid}`;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={style} aria-hidden="true" focusable="false">
      <defs>
        <radialGradient id={gradId} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#e43897" stopOpacity="0.7" />
          <stop offset="50%" stopColor="#a11a2a" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#0b0c10" stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx={c} cy={c} r={size * 0.48} fill={`url(#${gradId})`} />
      {Array.from({ length: 8 }).map((_, i) => {
        const a = (i / 8) * Math.PI * 2;
        const r1 = size * 0.14, r2 = size * 0.42;
        return (
          <line key={i}
            x1={c + Math.cos(a) * r1} y1={c + Math.sin(a) * r1}
            x2={c + Math.cos(a) * r2} y2={c + Math.sin(a) * r2}
            stroke={i % 2 === 0 ? '#e43897' : '#a11a2a'}
            strokeWidth={i % 2 === 0 ? 1.2 : 0.6} />
        );
      })}
      <circle cx={c} cy={c} r={size * 0.18} fill="none" stroke="#c9253a" strokeWidth="0.8" />
      <circle cx={c} cy={c} r={size * 0.07} fill="#c9253a" />
      <circle cx={c} cy={c} r={size * 0.035} fill="#ffd6e8" />
    </svg>
  );
}
